import app from './appSK';
export default {
    translation: {
        ...app
    }
    
};